/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import SearchResults from './SearchResults';

import useOnClickOutside from '../../../hooks/useOnClickOutside';

export default function SearchForm({
  placeholder = 'Search Borrowers',
  onResultSelect,
  queryFn,
  queryKey,
  formatSearchResult,
  noResultsText,
  queryFnParams,
  style,
}) {
  const [query, setQuery] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const formRef = useRef();
  const timer = useRef();

  useOnClickOutside(formRef, () => setIsFocused(false));

  const { data: results, refetch } = useQuery({
    queryKey: [...queryKey, query],
    queryFn: () => queryFn({ query, ...queryFnParams }),
    enabled: false,
  });

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (query) {
      timer.current = setTimeout(
        () =>
          /*  BorrowerService.searchBorrowers(query).then((response) => {
          setSearchResults(response);
        }), */
          refetch(),
        500
      );
    }
  }, [query, refetch]);

  return (
    <form className="relative w-full md:w-auto" ref={formRef} style={style}>
      <label htmlFor="action-search" className="sr-only">
        {placeholder}
      </label>
      <div>
        <input
          id="action-search"
          className="form-input pl-9 bg-white dark:bg-slate-800 w-full md:w-auto"
          style={style}
          type="search"
          placeholder={placeholder}
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onFocus={() => setIsFocused(true)}
        />
        {isFocused && (
          <SearchResults
            onResultSelect={onResultSelect}
            setQuery={setQuery}
            query={query}
            results={results}
            formatSearchResult={formatSearchResult}
            noResultsText={noResultsText}
          />
        )}
      </div>
      <button
        className="absolute inset-0 right-auto group pointer-events-none"
        type="button"
        aria-label="Search"
      >
        <svg
          className="w-4 h-4 shrink-0 fill-current text-slate-400 dark:text-slate-500 group-hover:text-slate-500 dark:group-hover:text-slate-400 ml-3 mr-2"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
          <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
        </svg>
      </button>
    </form>
  );
}
